import { createHOC } from 'vue-hoc';
import gql from 'graphql-tag';

import withUser from '~lib/common/hoc/withUser';
import auth from '~lib/common/providers/auth';
import userManagement from '~lib/common/providers/userManagement';
import casesService from '~lib/common/providers/casesService';

import CreateNotifications from './CreateNotifications';
import defaultTemplatesAccessContext from '../../../utils/defaultTemplatesAccessContext';


const options = {
  name: 'CreateNotificationsContainer',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      state: {
        loading: false,
        sending: false,
        cases: [],
        error: null,
      },
    };
  },
  async created() {
    if (!(await auth.isAuthenticated())) {
      this.$router.replace({ name: 'login' });
      return;
    }
    this.updateCases();
  },
  methods: {
    async updateCases() {
      try {
        this.state.loading = true;
        this.state.error = null;
        const accessContext = defaultTemplatesAccessContext[this.user['https://vrpatients.com/productType']];
        const response = await casesService.query({
          query: gql`
            query getCaseConfigurations($withAccess: AccessContextInput) {
              caseConfigurations(withAccess: $withAccess, sortBy: "name") {
                id
                name
              }
            }
          `,
          variables: {
            withAccess: accessContext,
          },
          fetchPolicy: 'network-only',
        });
        this.state.cases = response.data.caseConfigurations;
      } catch (e) {
        console.error(e);
        if (e.graphqlErrors && e.graphqlErrors.length) {
          this.state.error = e.graphqlErrors[0];
        }
        this.state.error = e;
      } finally {
        this.state.loading = false;
      }
    },
  },
};

const renderWith = {
  props: {
    loading() {
      return this.state.loading;
    },
    sending() {
      return this.state.sending;
    },
    cases() {
      return this.state.cases;
    },
    error() {
      return this.state.error;
    },
  },
  listeners: {
    async send(notification) {
      try {
        this.state.sending = true;
        this.state.error = null;
        await userManagement.post('/notifications', notification);
      } catch (error) {
        this.state.error = error;
      } finally {
        this.state.sending = false;
      }
    }
  },
};

const CreateNotificationsContainer = createHOC(CreateNotifications, options, renderWith);
export default withUser()(CreateNotificationsContainer);
